export const Roles = {
  CITY_ADMIN: 'city_admin',
  USER: 'user',
  ADVISOR: 'advisor',
  SUPER_ADMIN: 'super_admin',
};
